import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { CustomSwitch } from 'components';
import { useToaster } from 'Context/SnackbarContext';
import PointsConversionModal from './PointsConversionModal';
import { rewardsSubHeading, pointsConversionSubHeading } from '../../constants';
import { updateRedemptionSettings } from 'Services/apiFunctions';
import { handleEditRedemption } from '../../componentsUtil';
import { CATALOG } from 'components/Dashboard/Content/Catalog/constant';
import clsx from 'clsx';
import './style.scss';

const Index = ({ history, conversions, enableRewards, setEnableRewards, config, nameForPoints = 'Points' }) => {
    const dispatch = useDispatch();
    const { SetSnackbar } = useToaster();
    const queryClient = useQueryClient();
    const [openRewardsModal, setOpenRewardsModal] = useState(false);
    const [conversionModalData, setConversionModalData] = useState([]);

    const pointsConversionClasses = clsx({
        'd-flex': 1,
        'justify-content-between': 1,
        'align-item-center': 1,
    });

    const setModalData = (data) => {
        const result = data.map((item) => ({
            modified: false,
            originalValue: item.value,
            originalStatus: item.redemptionEnabled,
            ...item,
        }));
        setConversionModalData(result);
    };

    useEffect(() => {
        if (conversions?.length) {
            setModalData(conversions);
        }
    }, [conversions, config?.redemption]);

    const { mutateAsync: handleSave } = useMutation(updateRedemptionSettings);

    return (
        <div className='enable-rewards-config-container'>
            <div className='d-flex justify-content-between align-item-center separator'>
                <div className='d-flex flex-column'>
                    <h3 className='header-reward'>Enable redemptions for recognitions</h3>
                    <span className='sub-header-reward'>
                        {rewardsSubHeading}
                        <button onClick={() => history.push(CATALOG.HOME)}>catalog.</button>
                    </span>
                </div>
                <CustomSwitch
                    checked={enableRewards}
                    onClick={handleEditRedemption({
                        enableRewards,
                        setEnableRewards,
                        dispatch,
                        config,
                        queryClient,
                        SetSnackbar,
                        handleSave,
                    })}
                    name='editRewards'
                />
            </div>
            <div className={pointsConversionClasses}>
                <div className='d-flex flex-column'>
                    <h3 className='header-reward'>Points conversion rate</h3>
                    <span className='sub-header-reward'>{pointsConversionSubHeading(nameForPoints)}</span>
                    <button className='manage-rewards-button' onClick={() => setOpenRewardsModal(true)}>
                        Manage rewards for countries
                    </button>
                </div>
            </div>

            <PointsConversionModal
                open={openRewardsModal}
                setOpenRewardsModal={setOpenRewardsModal}
                onClose={() => {
                    setOpenRewardsModal(false);
                    setModalData(conversions);
                }}
                config={config}
                conversionModalData={conversionModalData}
                setConversionModalData={setConversionModalData}
                nameForPoints={nameForPoints}
                history={history}
            />
        </div>
    );
};

Index.propTypes = {
    history: PropTypes.object,
    conversions: PropTypes.array,
    config: PropTypes.object,
    nameForPoints: PropTypes.string,
    enableRewards: PropTypes.bool,
    setEnableRewards: PropTypes.func,
};

export default Index;
